import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export const CustomSnackbar = ({
  open,
  onClose,
  message,
  showAlert = true,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      {showAlert ? (
        <Alert onClose={onClose} severity="success" sx={{ width: '100%' }}>
          {message}
        </Alert>
      ) : (
        <div>{message}</div>
      )}
    </Snackbar>
  );
};